import { describeError } from '@/lib/apiClient';
import { useDashboardKpis } from '../dashboardApi';
import { toMonthlyRevenuePoints } from '../dashboardMetrics';
import { RevenueChart } from '../RevenueChart';

/**
 * Umsatzverlauf (fakturiert). Finanz-Widget — nur mit dashboard.viewfinancials (Registry).
 * Die Monatsreihe rechnet der Server über ALLE Belege (`GET /v1/dashboard/kpis`);
 * früher summierte der Browser die neuesten 200 Belege. Liefert der Server keinen
 * Umsatz (es fehlt `sales.read`), steht das da — nicht eine Null-Linie.
 */
export function RevenueWidget() {
  const kpis = useDashboardKpis();
  const revenue = kpis.data?.data.revenue;
  return (
    <RevenueChart
      points={revenue ? toMonthlyRevenuePoints(revenue.monthly) : []}
      isLoading={kpis.isLoading}
      error={kpis.isError ? describeError(kpis.error) : null}
      notice={revenue === null ? 'Umsatzzahlen sind für deine Rolle nicht freigegeben.' : null}
    />
  );
}
